// one level up: /projects/earthplace/privacy -> /projects/earthplace -> /projects -> /
export function parentPath(pathname: string) {
    const parts = pathname.replace(/\/+$/, "").split("/").filter(Boolean);
    return "/" + parts.slice(0, -1).join("/");
}
